module.exports = __webpack_public_path__ + "img/goToBack.db63a15e.png";